export enum Roles {
  Admin = 0,
  Editor = 1,
  CollabSiteCreator = 2,
  AppEditor = 3,
  MessageBroadcastEditor = 4,
  FooterEditor = 5,
  EditorDashboardEditor = 6,
  PowerBIEditor = 7
}
